/**
 * Format public variables.
 * @param {Record<string, string | boolean>} publicVars Public variables
 * @returns {Record<string, boolean | string>} Formatted public variables
 */
export const formatPublicVars = <T extends Record<string, string | boolean>>(
  publicVars: T,
): Record<keyof T, boolean | string> => {
  const result: Record<keyof T, boolean | string> = {} as Record<keyof T, boolean | string>;
  for (const [key, value] of Object.entries(publicVars)) {
    let val = value;
    try {
      // @ts-expect-error
      val = JSON.parse(value);
    } catch (_e) {}
    if (val === 'true' || val === true) {
      result[key as keyof T] = true;
    } else if (val === 'false' || val === false) {
      result[key as keyof T] = false;
    } else {
      result[key as keyof T] = value;
    }
  }
  return result;
};
